module.exports = __webpack_public_path__ + "img/NotaFiscal.efd3e344.png";